/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'account': {
    width: 18,
    height: 20,
    viewBox: '0 0 18 20',
    data: '<path pid="0" d="M13.274 5.743a4.423 4.423 0 1 0-8.846 0 4.423 4.423 0 1 0 8.846 0zm1 0a5.423 5.423 0 1 1-10.846 0 5.423 5.423 0 1 1 10.846 0zM6.283 12.28a.5.5 0 0 0-.49-.06L2.93 13.435a.493.493 0 0 0-.285.332l-1.063 4.119a.497.497 0 0 0 .48.619H15.64a.497.497 0 0 0 .482-.622l-1.064-4.116a.499.499 0 0 0-.286-.333l-2.86-1.212a.5.5 0 0 0-.493.058 4.306 4.306 0 0 1-5.136 0zm4.54-.803a1.502 1.502 0 0 1 1.478-.176l2.86 1.212c.429.181.75.554.866 1.004l1.063 4.115a1.496 1.496 0 0 1-1.45 1.873H2.062a1.496 1.496 0 0 1-1.45-1.87l1.064-4.118c.117-.452.439-.826.866-1.004l2.863-1.214a1.501 1.501 0 0 1 1.473.178c1.172.87 2.774.87 3.946 0z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/account.js